export default function Footer() {
    return (
        <footer className="border-t border-slate-200 bg-white px-4 sm:px-6 lg:px-10 py-4 mt-8">
            <div className="max-w-[1600px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                <div>© 2026 Emprenovus. Todos los derechos reservados.</div>
                <a
                    href="https://www.emprenovus.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-orange-600 transition-colors"
                    data-testid="footer-ai-link"
                >
                    <img src="/favicon.png" alt="Emprenovus" className="w-5 h-5 object-contain" />
                    AI powered by Emprenovus
                </a>
            </div>
        </footer>
    );
}
